import { OfficeSearchApiResponse, SlotsSearchResponseV4 } from '@src/lib/__generated/api';
import { trimTimeZoneOffset } from '@src/utils/trimTimeZoneOffset';

export const formatLabel = ({ location, slot }: { location: OfficeSearchApiResponse; slot: SlotsSearchResponseV4 }) => {
	const date = new Intl.DateTimeFormat('default', {
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	}).format(new Date(trimTimeZoneOffset(slot?.time) ?? ''));

	return ` on ${date} at ${location.title}`;
};
